import React from 'react';
import { useApp } from '../../context/AppContext';

// Footer standardisé - Le slogan et l'année sont définis ici pour être cohérents partout
const FOOTER_SLOGAN = "Découvrez, partagez, contemplez.";

function Footer() {
  const { actions } = useApp();
  const currentYear = new Date().getFullYear();

  const handleLegalClick = (type) => {
    let title = '';
    let content = '';

    switch (type) {
      case 'mentions':
        title = 'Mentions légales';
        content = `
          <h3>Éditeur du site</h3>
          <p>Sun-Spot<br/>
          Plateforme communautaire de découverte de spots panoramiques</p>
          
          <h3>Responsable de la publication</h3>
          <p>Équipe Sun-Spot</p>
          
          <h3>Hébergement</h3>
          <p>Les données sont hébergées sur des serveurs sécurisés.</p>
          
          <h3>Contact</h3>
          <p>contact@sun-spot.app</p>
        `;
        break;
      case 'conditions':
        title = 'Conditions d\'utilisation';
        content = `
          <h3>Acceptation des conditions</h3>
          <p>L'utilisation de Sun-Spot implique l'acceptation pleine et entière des présentes conditions.</p>
          
          <h3>Utilisation du service</h3>
          <p>Sun-Spot est une plateforme gratuite de partage et découverte de spots panoramiques.</p>
          
          <h3>Contenu utilisateur</h3>
          <p>Les utilisateurs sont responsables du contenu qu'ils publient.</p>
          
          <h3>Gratuité</h3>
          <p>Sun-Spot est et restera 100% gratuit, sans limitation d'utilisation.</p>
        `;
        break;
      case 'confidentialite':
        title = 'Politique de confidentialité';
        content = `
          <h3>Collecte des données</h3>
          <p>Nous collectons uniquement les données nécessaires au fonctionnement du service.</p>
          
          <h3>Utilisation des données</h3>
          <p>Vos données sont utilisées pour améliorer votre expérience sur Sun-Spot.</p>
          
          <h3>Protection des données</h3>
          <p>Nous mettons en œuvre toutes les mesures nécessaires pour protéger vos données personnelles.</p>
          
          <h3>Vos droits</h3>
          <p>Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données.</p>
        `;
        break;
      case 'cookies':
        title = 'Politique des cookies';
        content = `
          <h3>Qu'est-ce qu'un cookie ?</h3>
          <p>Les cookies sont de petits fichiers texte stockés sur votre appareil.</p>
          
          <h3>Utilisation des cookies</h3>
          <p>Nous utilisons des cookies essentiels pour le bon fonctionnement du site (authentification, préférences).</p>
          
          <h3>Gestion des cookies</h3>
          <p>Vous pouvez configurer votre navigateur pour refuser les cookies.</p>
        `;
        break;
      default:
        return;
    }

    actions.setLegalTitle(title);
    actions.setLegalContent(content);
    actions.setShowLegalModal(true);
  };

  return (
    <footer className="bg-white border-t border-gray-200 py-3 px-4">
      <div className="max-w-7xl mx-auto flex items-center justify-between text-sm text-gray-600">
        <div className="flex items-center space-x-1">
          <span>© {currentYear} Sun-Spot - {FOOTER_SLOGAN}</span>
        </div>
        
        <div className="flex items-center space-x-4">
          <button
            onClick={() => handleLegalClick('mentions')}
            className="hover:text-orange-600 transition-colors"
          >
            Mentions légales
          </button>
          <button
            onClick={() => handleLegalClick('conditions')}
            className="hover:text-orange-600 transition-colors"
          >
            Conditions d'utilisation
          </button>
          <button
            onClick={() => handleLegalClick('confidentialite')}
            className="hover:text-orange-600 transition-colors"
          >
            Confidentialité
          </button>
          <button
            onClick={() => handleLegalClick('cookies')}
            className="hover:text-orange-600 transition-colors"
          >
            Cookies
          </button>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
